import { type PropsWithChildren } from 'react';
import { RouterProvider } from 'react-aria-components';
import { useHref, useNavigate } from 'react-router';

const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

function useRouterHref(href: string): string {
  const routerHref = useHref(href);

  return ABSOLUTE_URL_REGEX.test(href) ? href : routerHref;
}

export function RacRouterProvider({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  return (
    <RouterProvider navigate={navigate} useHref={useRouterHref}>
      {children}
    </RouterProvider>
  );
}
